import React from 'react';
import '../Styles/TempCredit.css'

const TemporaryCredit = () => {
  return (
    <div>
    
     <div className ="account-entries">
            <div className="entries-header">
                <div>Show Entries 10</div>
        
                <div className="entries-controls">
                {/* Select Date Fields */}
                <input type="date" placeholder="From Date" />
                <input type="date" placeholder="To Date" />

                {/* Search Text Field */}
                <input type="text" placeholder="Search..." />

                {/* Buttons */}
                <button>Search</button>
                <button>Download</button>
            </div>
            </div>
            <div>
                <table>
                    <tr>
                        <th>#Ref no</th>
                        <th>Entry Date</th>
                        <th>Particulars</th>
                        <th>Amount</th>
                    </tr>
                    <tr>
                        <td> 1</td>
                        <td> 1</td>
                        <td> 1</td>
                        <td> 1</td>
                    </tr>
                    <tr>
                        <td className= "entries-pagination"  colspan="4">1</td>
                        </tr>
                </table>
            </div>
        </div>
        <div className='creditDue'>Credit Due ₹</div>
  </div>
  )
};

export default TemporaryCredit;